{
  "version": 1,
  "asset_id": "a9daa7f9-a56f-4a08-8e1a-b46ae2e91e3c",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a9daa7f9-a56f-4a08-8e1a-b46ae2e91e3c/wordmark-900.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a9daa7f9-a56f-4a08-8e1a-b46ae2e91e3c/wordmark-900.png",
  "original_filename": "wordmark-900.png",
  "size": 70426,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:19:25Z"
}
